
export const EQUIPMENT_TYPES = [
  "Air Handling Unit (AHU)",
  "Air Handler Unit 1",
  "Air Handler Unit 2",
  "Air Handler Unit 3",
  "Air Handler Unit 4",
  "Air Handler Unit 5",
  "Air Handler Unit 6",
  "Air Handler Unit 7",
  "Air Handler Unit 8",
  "Air Handler Unit 9",
  "Air Handler Unit 10",
  "Air Handler Unit 11",
  "Air Handler Unit 12",
  "Air Handler Unit 13",
  "Air Handler Unit 14",
  "Air Handler Unit 15",
  "Air Handler Unit 16",
  "Air Handler Unit 17",
  "Air Handler Unit 18",
  "Air Handler Unit 19",
  "Chiller",
  "Cooling Tower",
  "Boiler",
  "Fan Coil Unit",
  "Heat Pump",
  "Package Unit",
  "Split System",
  "VAV Box",
  "VRF System",
  "Elevator",
  "Elevator 1",
  "Elevator 2",
  "Elevator 3",
  "Elevator 4",
  "Elevator 5",
  "Elevator 6",
  "Elevator 7",
  "Elevator 8", 
  "Restroom",
  "Restroom 1",
  "Restroom 2",
  "Restroom 3",
  "Restroom 4",
  "Restroom 5",
  "Restroom 6",
] as const;
